// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32Pz8","input":"styles_input__1RXFz"};